import { SessionService } from "services/sessionService";

export const AppImages = {
    GroupThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/a16d284e-537c-4c8b-8a47-45afabaeed48`,
    TopicThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/ff9e80f9-e583-4fb8-ace6-64db5ab14e04`,
    UnitTypeThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/54c04b24-0e40-4d6a-890f-d1dd48e052bf`,
    UserThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/e6b93810-7ff7-497a-8e9b-c77f344faea9`,
    UserProfileBackground: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/4defc8ff-de05-48ea-aa77-1b6be65fa22a`,
    BannerBackground: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/a1077f18-a2d4-40b4-8acd-ca40ced2f611`,
    CarouselLink: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/8ed8399d-08e8-406b-b8c3-1d4628c9a71d`,
    UserProfileProfessionalInterest: "/img/app/Foundation-UserProfileProfessionalInterest.png",
    UserProfilePersonalInterest: "/img/app/Foundation-UserProfilePersonalInterest.png",
    UserProfileCurriculum: "/img/app/Foundation-UserProfileCurriculum.png",
    UserProfileProficience: "/img/app/Foundation-UserProfileProficience.png",

    KnowledgeChannelThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/1c9f9d8c-8d7b-475c-b429-d2573f4f4987`,
    KnowledgeListThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/b42a2c65-d77c-4e57-b70b-b9b37d89a486`,
    KnowledgeListFavoriteThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/fe29c2ff-7ce6-4810-9491-6084584a6ae5`,
    KnowledgeListSeeLaterThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/a2fd90d0-d452-445c-838e-b5f82d9586c9`,
    KnowledgeInstitutionalThumbnail: `${SessionService.current.apiPaths.coreApi}/images/Knowledge-InstitutionalThumbnail.png`,

    PublicationTypeListThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/b42a2c65-d77c-4e57-b70b-b9b37d89a486`,
    PublicationTypePostThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/8ba14a75-da81-4135-96c2-8d02077b3d23`,
    PublicationTypeQuestionThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/e4a0bfbc-8e29-48f0-9841-b7fc0a8a870f`,
    PublicationTypeAnswerThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/9970689f-548a-47bb-bfd8-a87d14670a19`,
    PublicationTypePollThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/fcb4a60c-db16-4b82-887e-a88d3de51ef2`,
    PublicationTypeUnknowThumbnail: "/img/app/Knowledge-PublicationType-Unknow.png",

    AwardBadgeThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/1eefe681-b52a-6700-956f-483e883021e7`,

    AssessmentEvaluationThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/c56e2619-4500-4e0a-b610-6c0b994c03e1`,
    AssessmentSurveyThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/cd461aae-c0c2-4b19-80f2-3e9a2175cc14`,
    AssessmentTopicChallengeThumbnail: `${SessionService.current.apiPaths.coreApi}/images/Ass-TopicChallengeThumbnail.png`,
    AssessmentPlayerCorrect: "/img/app/Ass-Check-Correct.gif",
    AssessmentWrong: "/img/app/Ass-Wrong.gif",
    AssessmentEvaluationFeedback: "/img/app/Ass-Evaluation-Feedback.png",

    LmsContentTypeActivityThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/9b081db1-0f3f-4f96-b310-123af46808a6`,
    LmsContentTypeEvaluationThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/307cffeb-b430-4e68-8734-926f00bd5d41`,
    LmsContentTypeSurveyThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/36a06954-a413-42c5-9ed5-a8dc4dfd42fb`,
    LmsContentTypeWebAndLiveThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/f22a2225-38c4-4a32-be0b-553d7901e6cd`,
    LmsContentTypeLiveOnLineThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/bec1922b-835f-49f0-8bc6-313eda6179e3`,
    LmsContentTypeLivePresentialThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/81921354-637e-4d23-8bac-0f5a6209a0ba`,
    LmsContentTypeLiveMixlThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/854f1a5b-e87c-4db5-9f89-27c9f7a168bd`,
    LmsContentTypeCourseWebThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/a04ce999-a739-4b1f-a57c-ee69df02daf0`,
    LmsContentTypeLearnPathThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/44706f5a-6977-45ad-bbf5-bee05b4d7d2a`,
    LmsContentTypeExternalCourseThumbnail: `${SessionService.current.apiPaths.coreApi}/GetSystemImage/1b5e2ef2-0296-4f7b-be36-6161fc4d7f12`,

    EmptyImageThumbnail: "/img/app/App-Image-Empty.png",
    UnknownImageThumbnail: "/img/app/App-Image-Unkown.png",
    TakePicture: "/img/app/App-Take-Picture.png",
    VideoProcessingThumbnail: "/img/app/App-Video-Processing-Thumbnail.png",
    VideoProcessingPoster: "/img/app/App-Video-Processing-Poster.png",
    VideoMp4Thumbnail: "/img/app/App-Video-MP4-Thumbnail.png",
    VideoMp4Poster: "/img/app/App-Video-MP4-Poster.png",
    AudioThumbnail: "/img/app/App-Audio-Thumbnail.png",
    AudioPoster: "/img/app/App-Audio-Poster.png",
};

export const AppImageDimension = {

    CardPicture: { width: 640, height: 360 } as ImageDimension,

    ImageEditor: { width: 256, height: 256 } as ImageDimension,

    SquarePicture: { width: 128, height: 128 } as ImageDimension,

    ThumbnailWide: { width: 220, height: 124 } as ImageDimension,

    BadgePicture: { width: 96, height: 128 } as ImageDimension,

    ThumbnailIcon: { width: 48, height: 48 } as ImageDimension,

    CardNotice: { width: 341, height: 124 } as ImageDimension,

    UserBackground: { width: 540, height: 360 } as ImageDimension,

    MapGameBackground: { width: 876, height: 400 } as ImageDimension,

    ThumbnailKnowledgeTests: { width: 200, height: 250 } as ImageDimension,

    BannerBackgroundImage: { width: 320, height: 180 } as ImageDimension
};
